module.exports = __webpack_public_path__ + "67fd7eb5a9d7a92127ab58a0d64192de.svg";